module.exports = __webpack_public_path__ + "img/profile-circle.66c28656.svg";